













import Label from '@/components/Label2.vue';
import ArrowDown from '@/components/ArrowDown.vue';
import { mapState } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Label,
    ArrowDown,
  },
  computed: mapState(['isMobole']),
})
export default class EnjoySafety extends Vue {
  mounted() {}
  toRouter(i) {
    this.$store.commit('setCurrentPage', i);
  }
}
